import type { AdminProgrammeOverview, ProgrammeOnboardingState, ProgrammeStage } from '@sparkapp/shared-types';

export const STAGE_LABELS: Record<ProgrammeStage, string> = {
  registration: 'Registration open',
  in_progress: 'In progress (registration closed)',
  on_hold: 'On hold',
  concluded: 'Concluded',
};

/** Non-final states, in screen order. */
export const IN_PROGRESS_STATES: { state: ProgrammeOnboardingState; label: string }[] = [
  { state: 'invited', label: 'Invited' },
  { state: 'eligibility_check', label: 'Checking eligibility' },
  { state: 'eligible', label: 'Eligible (deciding)' },
  { state: 'eligible_agree', label: 'Agreed' },
  { state: 'family_info', label: 'Family info done' },
  { state: 'child_info', label: 'Child info done' },
  { state: 'confidence', label: 'Confidence done' },
];

export const OUTCOME_STATES: { state: ProgrammeOnboardingState; label: string }[] = [
  { state: 'completed', label: 'Joined' },
  { state: 'not_joining', label: 'Not joining' },
  { state: 'not_eligible', label: 'Not eligible' },
  { state: 'eligible_disagree', label: 'Disagreed' },
  { state: 'programme_full', label: 'Programme full' },
  { state: 'abandoned', label: 'Abandoned' },
];

/** What a status change does, for the confirmation modal. Uses the live counts. */
export function stageChangeEffect(
  from: ProgrammeStage,
  to: ProgrammeStage,
  { programme, places, onboarding }: AdminProgrammeOverview,
): string {
  const midFlow = (n: number) => `${n} ${n === 1 ? 'family is' : 'families are'} mid-onboarding`;
  const target: Record<ProgrammeStage, string> = {
    registration: `Registration reopens. Verified families who have not started the assessment will be invited at sign-in while places remain (${places.remaining} left).`,
    in_progress: `No new families will be invited. ${midFlow(onboarding.inProgress)}: they can finish if they stay in the app (up to the hard limit of ${programme.hardLimit}); if they close and reopen the app they go to assessment onboarding instead.`,
    on_hold: `The programme is paused. No new families will be invited. ${midFlow(onboarding.inProgress)}: they can finish if they stay in the app; if they close and reopen it they go to assessment onboarding instead. You can restart it later.`,
    concluded: `The programme ends. No new invites, and families mid-onboarding go to assessment onboarding when they next open the app. ${places.registered} registered families are not affected. You can restart it later.`,
  };
  if (from === 'on_hold' && to !== 'concluded') return `The programme restarts. ${target[to]}`;
  if (from === 'concluded') return `The programme becomes the active programme again. ${target[to]}`;
  return target[to];
}
